import React, {FC, createContext, useContext, ReactNode} from 'react'
import {usersAPI} from '../../services/UsersService'

const defaultLang = (navigator.language || 'en').split('-')[0]

type Lang = 'en' | 'ru'

const normalizedLang: Lang = defaultLang === 'ru' || defaultLang === 'en' ? (defaultLang as Lang) : 'en'

type Props = {
  selectedLang: Lang
}

const initialState: Props = {
  selectedLang: normalizedLang,
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

type WithChildren = {
  children?: ReactNode
}

const RootI18nProvider: FC<WithChildren> = ({children}) => {
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const lang = currentUser ? ({selectedLang: currentUser?.language} as Props) : initialState
  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export {RootI18nProvider, useLang}
